import React from "react";

interface LoadingSpinnerProps {
  label?: string;
}

/** Inline loading indicator. (The previous version was a Bootstrap modal
 *  without `show`, which rendered as display:none — i.e. nothing at all.) */
const LoadingSpinner = ({ label = "Loading, please wait..." }: LoadingSpinnerProps) => {
  return (
    <div className="d-flex align-items-center gap-2 text-muted my-2" role="status">
      <span className="spinner-border spinner-border-sm text-primary" aria-hidden="true"></span>
      <span>{label}</span>
    </div>
  );
};

export default LoadingSpinner;
